import dJSON from 'dirty-json';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.message-cards-wrapper';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.message-cards').insertAdjacentHTML('beforeend', /* html */ `
          <a class="message-card" href="${item.link}">
            <div class="message-card__image">
              <img src="${item.backgroundImage}">
              <div class="initial-overlay"></div>
              <div class="hover-overlay"></div>
            </div>
            <div class="message-card__content">
              <p class="message-card__title">${item.title}</p>
              <p class="message-card__description">${item.description}</p>
            </div>
          </a>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
